export default "__VITE_ASSET__DpAGkds$__"